import { render } from "./ClinicalComments.vue?vue&type=template&id=fb45cd1e&ts=true"
import script from "./ClinicalComments.ts?vue&type=script&lang=ts&external"
export * from "./ClinicalComments.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__